import {
    UPLOAD_SLIDER_REQUEST,
    UPLOAD_SLIDER_SUCCESS,
    UPLOAD_SLIDER_FAILURE,
    GET_SLIDERS,
    DELETE_SLIDER,
    GET_PROYECTOS,
    UPLOAD_NOTIFICATION_REQUEST,
    UPLOAD_NOTIFICATION_SUCCESS,
    UPLOAD_NOTIFICATION_FAILURE,
    GET_LATEST_MANHWAS,
    FETCH_PROYECTOS_PAGINATED_SUCCESS,
    GET_NOTIFICACIONES,
    GET_LAST_NOTIFICATION,
    GET_POPULAR_SERIES,
    GET_AFILIADOS,
    GET_COMENTARIOS,
    DELETE_COMENTARIOS_PROYECTOS,
} from '../acciones/index.js';

const estadoInicial = {
    usuariosTotal: [],
    afiliados: [],
    detalleUsuario: {},

    totalProyectos: [],
    detalleProyecto: {},

    totalCapitulos: [],
    detalleCapitulo: {},

    totalSlider: [],
    detalleSlider: {},

    usuarioFilter: [],
    proyectosFilter: [],

    isAuthenticated: false,
    user: null,
    token: null,
    error: null,

    sliders: [],
    loading: false,

    popularSeries: [],

    notificaciones: [], // Estado inicial vacío
    loadingNotification: false,
    errorNotification: null,

    latestManhwas: {
        subidos: [],
        actualizados: [],
    },

    manhwas: [],
    proyectos: [],
    totalPages: 1,
    currentPage: 1,

    lastNotification: {},
    comentarios: [],
    usuarios: [],
    comentariosProyectos: [],
};



export const rootReducer = (state = estadoInicial, action) => {
    switch (action.type) {

        case GET_SLIDERS:
            return {
                ...state,
                sliders: action.payload // Asegúrate de que sea un array
            };

        case DELETE_SLIDER:
            return {
                ...state,
                sliders: state.sliders.filter(slider => slider.slider_id !== action.payload)
            };

        case UPLOAD_SLIDER_SUCCESS:
            return {
                ...state,
                sliders: [...state.sliders, action.payload],
                loading: false,
            };

        case UPLOAD_SLIDER_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case 'GET_USUARIOS':
            state.usuarioFilter = [];
            return {
                ...state,
                usuariosTotal: action.payload
            };

        case 'GET_CAPITULOS':
            return {
                ...state,
                totalCapitulos: action.payload
            };

        case 'GET_USUARIOS_NOMBRE':
            return {
                ...state,
                usuarioFilter: action.payload
            };

        case 'GET_PROYECTOS_NOMBRE':
            return {
                ...state,
                proyectosFilter: action.payload
            };

        case 'GET_USUARIOS_DETALLE':
            return {
                ...state,
                detalleUsuario: action.payload
            };

        case 'GET_PROYECTO_DETALLE':
            return {
                ...state,
                detalleProyecto: action.payload
            };

        case 'GET_CAPITULO_DETALLE':
            return {
                ...state,
                detalleCapitulo: action.payload
            };

        case 'GET_SLIDER_DETALLE':
            return {
                ...state,
                detalleSlider: action.payload
            };

        case 'UPDATE_USUARIO_RANGO':
            return {
                ...state,
                usuariosTotal: state.usuariosTotal.map(usuario =>
                    usuario.user_id === action.payload.user_id ? action.payload : usuario
                )
            };




        case 'PROYECTO_FILTER_GENERO':
            return {
                ...state,
                proyectosFilter: state.totalProyectos.filter(proyecto => proyecto.generos.map(genero => genero.nombre)[0] === action.payload || proyecto.generos.map(genero => genero.nombre)[1] === action.payload)
            }

        ///////////////////////////////////////////////////////////////////////////////////////

        case 'REGISTER_SUCCESS':
            return {
                ...state,
                error: null
            };
        case 'REGISTER_FAILURE':
            return {
                ...state,
                error: action.payload
            };
        case 'LOGIN_SUCCESS':
            return {
                ...state,
                isAuthenticated: true,
                user: action.payload.user,
                token: action.payload.token,
                error: null
            };
        case 'LOGIN_FAILURE':
            return {
                ...state,
                error: action.payload
            };

        case UPLOAD_SLIDER_REQUEST:
            return { ...state, loading: true, error: null };


        case 'GET_PROYECTOS':
            return {
                ...state,
                proyectos: action.payload.proyectos,
                proyectosFilter: [],
                currentPage: action.payload.currentPage,
                totalPages: action.payload.totalPages,
            };

        case 'ADD_POPULAR_SERIES':
            return {
                ...state,
                popularSeries: [...state.popularSeries, action.payload],
            };

        case UPLOAD_NOTIFICATION_REQUEST:
            return {
                ...state,
                loadingNotification: true,
                errorNotification: null
            };

        case UPLOAD_NOTIFICATION_SUCCESS:
            return {
                ...state,
                notificaciones: [...state.notificaciones, action.payload],
                loadingNotification: false,
            };

        case UPLOAD_NOTIFICATION_FAILURE:
            return {
                ...state,
                loadingNotification: false,
                errorNotification: action.payload
            };

        case GET_LATEST_MANHWAS:
            return {
                ...state,
                latestManhwas: action.payload,
            };

        case FETCH_PROYECTOS_PAGINATED_SUCCESS:
            return {
                ...state,
                manhwas: action.payload.proyectos, // Accede a la propiedad correcta
                totalPages: action.payload.totalPages,
                currentPage: action.payload.currentPage,
            };

        case GET_NOTIFICACIONES:
            console.log('GET_NOTIFICACIONES action received:', action.payload); // Verifica la carga útil
            return {
                ...state,
                notificaciones: action.payload,
            };

        case GET_LAST_NOTIFICATION:
            return {
                ...state,
                lastNotification: action.payload,
            };

        case GET_POPULAR_SERIES:
            return {
                ...state,
                popularSeries: action.payload || { hoy: [], semana: [], todos: [] },
            };

        case GET_AFILIADOS:
            console.log("Afiliados procesados en el reducer:", action.payload);
            return {
                ...state,
                afiliados: action.payload, // Almacena la lista de afiliados
            };

        case 'GET_USUARIO_PERFIL':
            return {
                ...state,
                detalleUsuario: action.payload,
            };

        case GET_COMENTARIOS:
            console.log("Comentarios procesados en el reducer:", action.payload);
            return {
                ...state,
                comentarios: action.payload, // Almacena la lista de comentarios
            };

        case 'DELETE_COMENTARIO':
            return {
                ...state,
                comentarios: state.comentarios.filter(comentario => comentario.comentario_id !== action.payload)
            };

        case 'DELETE_USUARIO':
            return {
                ...state,
                usuarios: state.usuarios.filter(usuario => usuario.user_id !== action.payload)
            };

        case DELETE_COMENTARIOS_PROYECTOS:
            return {
                ...state,
                comentariosProyectos: state.comentariosProyectos.filter(comentarioProyecto => comentarioProyecto.comentario_id !== action.payload)
            };



        default: return state;
    }
}